const translations = {
  title: 'Questionários',
  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'menu.category': 'Cadastro de categorias',
  name: 'Nome',
  actions: 'Ações',
  availableIn: 'Disponível em',
  type: 'Tipo',
  updatedAt: 'Última atualização',
  enabled: 'Ativado',
  searchOnlyThisEnvironment: 'Pesquisar somente neste ambiente',
  searchOnlyThisEnvironmentTooltip:
    'Por padrão a pesquisa é feita na base de templates. Ao ativar essa opção, a pesquisa será feita somente neste ambiente.',
  createNew: 'Criar um novo',
  createNewDescription: 'Novo questionário em branco.',
  new: 'Novo',
  templates: 'Templates'
}

export default translations
